import { createActions } from 'redux-actions'

export const {
  job: {
    getDetail: getJobDetail,
    getDetailSuccess: getJobDetailSuccess,
    getDetailFailure: getJobDetailFailure,
    jobContentLoaded
  }
} = createActions({
  JOB: {
    GET_DETAIL: [id => ({ id }), (id, { ...meta } = {}) => ({ ...meta })],
    GET_DETAIL_SUCCESS: [info => ({ info }), (payload, meta) => meta],
    GET_DETAIL_FAILURE: [message => ({ message }), (payload, meta) => meta],
    JOB_CONTENT_LOADED: () => ({})
  }
})
